import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { Observable } from 'rxjs';
import { DKJordPolygonResult, GeusLocationCalculateCommand, LocationGeusData, LocationGeusDataV2 } from '../contracts';

@Injectable()
export class GeusCalculationService {
  constructor(private readonly http: HttpClient) {}

  public startGeuscalculation(
    locationNumber: string
  ): Observable<LocationGeusData> {
    const url =
      AppConfig.apiUrls.locations.geusCalculateDKjordLocation(locationNumber);
    return this.http.get<LocationGeusData>(url);
  }

  /**
   * Checks the status of the Jupiter XL database.
   * @returns Observable<boolean> - true if database is reachable, false otherwise
   */
  public checkJupiterXlDatabaseStatus(): Observable<boolean> {
    const url = AppConfig.apiUrls.locations.checkJupiterXlDatabaseStatus();
    return this.http.get<boolean>(url);
  }

  /**
   * Fetches the DKJord polygons for a specific location.
   * @param locationNumber - location number
   * @returns Observable<DKJordPolygonResult> - result containing the polygons
   */
  public fetchDkJordPolygons(locationNumber: string): Observable<DKJordPolygonResult> {
    const url = AppConfig.apiUrls.locations.fetchDkJordPolygons(locationNumber);
    return this.http.get<DKJordPolygonResult>(url);
  }

  /**
   * Calculates the GEUS data by polygon.
   * @param locationNumber - location number
   * @param pollutionStatus - type of the polygon
   * @param shapeWkt - WKT representation of the shape
   * @returns Observable<LocationGeusDataV2> - result containing the GEUS data
   */
  public geusCalculateByPolygon(locationNumber: string, pollutionStatus: string, shapeWkt: string): Observable<LocationGeusDataV2> {
    const url = AppConfig.apiUrls.locations.geusCalculateByPolygon();
    const command = new GeusLocationCalculateCommand({locationNumber, pollutionStatus, shapeWkt});
    return this.http.post<LocationGeusDataV2>(url, command);
  }
}
